import React from 'react';
import { Paper, Box, Typography, Divider, TextField, FormControl, InputLabel, Select, MenuItem, Chip } from '@mui/material';

const ROLES = [
  { value: 'teacher', label: 'Docente' },
  { value: 'member', label: 'Membro' },
];

const TeacherDetailsInfo = ({ teacher }) => {
  const getRoleLabel = (role) => {
    switch (role) {
      case 'admin':
        return 'Amministratore';
      case 'teacher':
        return 'Docente';
      case 'member':
        return 'Membro';
      default:
        return role;
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Informazioni Docente
      </Typography>
      <Divider sx={{ mb: 2 }} />
      
      <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
        {/* Prima riga: Nome e Cognome */}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            name="name"
            label="Nome"
            value={teacher?.name || ''}
            sx={{ flex: 1 }}
            InputProps={{ readOnly: true }}
          />
          <TextField
            name="surname"
            label="Cognome"
            value={teacher?.surname || ''}
            sx={{ flex: 1 }}
            InputProps={{ readOnly: true }}
          />
        </Box>

        {/* Seconda riga: Email e Telefono */}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            name="email"
            label="Email"
            value={teacher?.email || ''}
            sx={{ flex: 1 }}
            InputProps={{ readOnly: true }}
          />
          <TextField
            name="telephone"
            label="Telefono"
            value={teacher?.telephone || ''}
            sx={{ flex: 1 }}
            InputProps={{ readOnly: true }}
          />
        </Box>

        {/* Terza riga: Telefono Secondario e Ruolo */}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            name="telephoneSecondary"
            label="Telefono Secondario"
            value={teacher?.telephoneSecondary || ''}
            sx={{ flex: 1 }}
            InputProps={{ readOnly: true }}
          />
          <FormControl sx={{ flex: 1 }}>
            <InputLabel>Ruolo</InputLabel>
            <Select
              name="roles"
              label="Ruolo"
              value={teacher?.roles || []}
              multiple
              disabled
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((role) => (
                    <Chip key={role} label={getRoleLabel(role)} size="small" />
                  ))}
                </Box>
              )}
            >
              {ROLES.map((role) => (
                <MenuItem key={role.value} value={role.value}>
                  {role.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </Paper>
  );
};

export default TeacherDetailsInfo;
